export default {
  GENERAL: {
    REG_EXPR: {
      EMAIL_REG_EXPR: /^([a-zA-Z0-9_\-\.!#$%&'*+=?^_`{|}~.]{0,64})@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
      PHONE_REG_EXPR: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      PHONE_REG_EXPR2: /\d{8,15}$/,
      PHONE_REG_EXPR3: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3} - [0-9]{4}$/,
      ONLY_DIGITS: /^\d+$/,
      ONLY_ALPHABETS: /^[a-zA-Z]+$/,
      PHONE_FORMAT: /(\((\d+)\)\-(\d+)\-(\d+))/,
      IS_STRING_EMPTY: /^\s*$/,
      POSITIVE_FLOAT: /^\d*(\.\d+)?$/,
      INTEGER_FIXED_TO_2: /^\d*\.?\d{0,2}$/,
      INTEGER_FIXED_TO_5: /^\d*\.?\d{0,7}$/,
      FIXED_TO_2: /^-?\d*\.?\d{0,2}$/,
      FIXED_TO_5: /^-?\d*\.?\d{0,7}$/
    }
  }
};
export var BOOKING_TYPE = {
  REGULAR: 'regular',
  QUICK: 'quick'
};
export var EMPTY_ARRAY = Object.freeze([]);